<template>
<svg xmlns="http://www.w3.org/2000/svg" width="14.203" height="8.601" viewBox="0 0 14.203 8.601">
<path id="Path_111" data-name="Path 111" d="M498.842,3107.294l4.98,4.98,4.98-4.98" transform="translate(-496.72 -3105.173)" fill="none" stroke="#ffffff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
</svg>
</template>